import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

type CostBreakdownDatum = {
  name: string;
  value: number;
  color: string;
};

interface CostBreakdownStructureCardProps {
  data: CostBreakdownDatum[];
  cardTitle?: string;
  cardSubTitle?: string;
  cardbadge?: string;
  insightTitle?: string;
  insightText?: string;
  emptyState?: React.ReactNode;
  isShowTags?: boolean;
}

function DonutLegend({ data }: { data: CostBreakdownDatum[] }) {
  return (
    <div className="cma-donut-legend">
      {data.map((d) => (
        <div key={d.name} className="cma-donut-legend-item">
          <div className="cma-donut-legend-dot" style={{ background: d.color }} />
          <span className="cma-donut-legend-name">{d.name}</span>
          <span className="cma-donut-legend-value">{d.value}%</span>
        </div>
      ))}
    </div>
  );
}

export function CostBreakdownStructureCard({
  data,
  cardTitle,
  cardSubTitle,
  cardbadge,
  insightTitle,
  insightText,
  emptyState,
  isShowTags = true,
}: CostBreakdownStructureCardProps) {
  return (
    <div className="cma-card">
      <div className="cma-card-header">
        {(cardTitle || cardSubTitle) &&(<div>
          {cardTitle && <div className="cma-card-title">{cardTitle ?? "Cost Breakdown Structure (CBS)"}</div>}
          {cardSubTitle && <div className="cma-card-subtitle">{cardSubTitle ?? "All-in cost composition - Well Construction Services"}</div>}
        </div>
        )}
        {isShowTags && (
          <span className="cma-card-badge cma-card-badge-purple">{cardbadge}</span>
        )}
      </div>
      {data.length > 0 ? (
        <>
          <div className="flex items-center cma-cbs-wrap">
            <div className="cma-cbs-chart">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Tooltip
                    contentStyle={{ fontSize: 12, borderRadius: 6 }}
                    formatter={(value: number, name: string) => [`${value}%`, name]}
                  />
                  <Pie data={data} cx="50%" cy="50%" innerRadius={40} outerRadius={80} dataKey="value" nameKey="name" startAngle={90} endAngle={-270} paddingAngle={2}>
                    {data.map((d, i) => (
                      <Cell key={`${d.name}-${i}`} fill={d.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="cma-cbs-legend-wrap">
              <DonutLegend data={data} />
            </div>
          </div>
          {insightTitle && insightText ? (
          <div className="cma-insight-box">
            <div className="cma-insight-title">{insightTitle}</div>
            <div className="cma-insight-text">{insightText}</div>
          </div>
        ) : null}
        </>
      ) : (
        emptyState ?? <div className="cma-no-records">No Records Found</div>
      )}
    </div>
  );
}
